import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section className="banner_point text_white bg_purple_color bg_circle">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo mb-4">
              <StaticImage
                src="../../../images/case-studies/rev-coin/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={221}
                height={153}
              />
            </div>
            <h1>Empowering Employees through Crypto Stock-Based Solutions</h1>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/rev-coin/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={842}
                height={602}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
